import { useCallback, useEffect, useState } from "react";
import { generateUniqueID } from "./utils";

/**
 * Manages the playback session id used as `videostart_id` in analytics.
 * When `videoStartId` is provided, syncs from the prop; otherwise regenerates on `videoId` change.
 */
export function usePlaybackUniqueId({ videoStartId, videoId }) {
  const externalId = videoStartId ?? null;

  const [uniqueId, setUniqueId] = useState(
    () => externalId ?? generateUniqueID()
  );

  useEffect(() => {
    const nextId = externalId || generateUniqueID();
    setUniqueId(nextId);
  }, [videoId, externalId]);

  const setVideoStartId = useCallback(id => {
    setUniqueId(id || generateUniqueID());
  }, []);

  const resetUniqueId = useCallback(() => {
    setUniqueId(generateUniqueID());
  }, []);

  return { uniqueId, setVideoStartId, resetUniqueId };
}
